import { Else, If, Then } from 'react-if';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useLogger } from 'react-use';

import PageTemplate from 'components/page-template/PageTemplate';
import PrivateRoute from 'components/PrivateRoute';
import ApplicationContextProvider from 'contexts/application/ApplicationContextProvider';
import useUserContext from 'contexts/user/useUserContext';
import ApplicantPage from 'pages/applicant/ApplicantPage';
import { ApplicationListPage } from 'pages/application-list/ApplicationListPage';
import DevPage from 'pages/dev/DevPage';
import ImpersonationPage from 'pages/ImpersonationPage';
import LoginPage from 'pages/login-page/LoginPage';
import { PageNotFound } from 'pages/not-found/PageNotFound';
import ProcessUsageBasedSubscription from 'pages/ProcessUsageBasedSubscription';
import RequestResetPassword from 'pages/RequestResetPassword';
import ResetPassword from 'pages/ResetPassword';
import SettingsPage from 'pages/settings-page/SettingsPage';

export default function RouteIndex(): JSX.Element {
  const { isLoggedIn } = useUserContext();
  useLogger('RouteIndex');

  return (
    <Routes>
      <Route
        path='*'
        element={(
          <PageTemplate>
            <PageNotFound />
          </PageTemplate>
      )}
      />
      <Route
        path='/'
        element={(
          <If condition={!isLoggedIn}>
            <Then>
              <Navigate to='/login' />
            </Then>
            <Else>
              <Navigate to='/' />
            </Else>
          </If>
        )}
      />
      <Route path='/login' element={<LoginPage />} />
      <Route
        path='/request-reset-password'
        element={<RequestResetPassword />}
      />
      <Route path='/reset-password' element={<ResetPassword />} />
      <Route path='/impersonate' element={<ImpersonationPage />} />
      <Route element={<PrivateRoute />}>
        <Route index element={<ApplicationListPage />} />
        <Route
          path='/application/:applicationId/applicant/:applicantId'
          element={(
            <ApplicationContextProvider>
              <ApplicantPage />
            </ApplicationContextProvider>
  )}
        />

        <Route path='/dev' element={<DevPage />} />
        <Route path='/settings' element={<Navigate to='/settings/my-profile' />} />
        <Route path='/settings/:tabName' element={<SettingsPage />} />
        <Route path='/process-usage-based-billing-setup' element={<ProcessUsageBasedSubscription />} />
      </Route>
    </Routes>
  );
}
